// Interface Endereco baseada no OpenAPI
export interface Endereco {
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  pais: string;
  complemento?: string;
  ibge?: string;
}

// Classes utilitárias para conversão e manipulação
export class EnderecoModel {
  static empty(): Endereco {
    return {
      logradouro: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: '',
      pais: '',
      complemento: undefined,
      ibge: undefined,
    };
  }

  static fromMap(map: Record<string, unknown>): Endereco {
    return {
      logradouro: (map.logradouro as string) || '',
      numero: (map.numero as string) || '',
      bairro: (map.bairro as string) || '',
      cidade: (map.cidade as string) || '',
      estado: (map.estado as string) || '',
      cep: (map.cep as string) || '',
      pais: (map.pais as string) || '',
      complemento: map.complemento as string,
      ibge: map.ibge as string,
    };
  }

  static listFromMap(list: unknown[]): Endereco[] {
    return list.length === 0 ? [] : list.map(item => EnderecoModel.fromMap(item as Record<string, unknown>));
  }
}
